/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { StorageModule } from "@vlinder-web/storage-module-react";


const storageService = StorageModule.getInstance();
const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");

 export const profileDetail = {
     name:"",
     description:"",
    //  profileImg: `${DEFAULT_APP_CONFIG?.servers?.rest?.imageServer}/imgbb/hYL6WL0/avatar-default.png/:/rs=w:100`,
    //  bannerImg: `${DEFAULT_APP_CONFIG?.servers?.rest?.imageServer}/imgbb/7bt6Jcg/profile-banner.jpg/:/rs=w:1500`
    profileImg: `https://i.ibb.co/hYL6WL0/avatar-default.png`,
    bannerImg: `https://i.ibb.co/7bt6Jcg/profile-banner.jpg`
 }
// [
//     {
//         key: "name",
//         title: "name",
//         value: "Lorem Name",
//     },
//     {
//         key: "unique_id",
//         title: "unique ID",
//         value: "IX5433A",
//     },
//     {
//         key: "verified_user",
//         title: "verified",
//         value: false,
//         type: "verify",
//     },
//     {
//         key: "email",
//         title: "email",
//         value: "lorem@loremmm.com",
//     },
//     {
//         key: "address",
//         title: "address",
//         value: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus at nunc porttitor, gravida libero et, efficitur nunc. Vivamus blandit porttitor felis, ut scelerisque dolor. ",
//     },
// ];

export const walletDetail = [
    // {
    //     key: "user_img",
    //     value: "https://i.picsum.photos/id/1044/4032/2268.jpg?hmac=BXmoMkaurlzpTLYQupXLipcmI1sFbgT5sIz98Ob5VZE"
    // },
    {
        key: "name",
        title: "name",
        value: "Lorem Name",
    },
    {
        key: "email",
        title: "email",
        value: "lorem@loremmm.com",
    },
    {
        key: "account_id",
        title: "Account-Id",
        value: "643r3434fe33323v9u98f88V8u8",
    },
    {
        key: "account_address",
        title: "Account-Address",
        value: "vskf22wfksdcndnf32229fsfsf42848913f9fe0di93n31j3224",
    },
    {
        key: "email_verified",
        title: "Email-verified",
        value: true,
        type: "verify",
    },
    {
        key: "wallet_verified",
        title: "Wallet-Verified",
        value: false,
        type: "verify",
    },
];

export const transactionsDetails = [
    {
        idx: "2",
        Title: "CASABLANCA",
        Description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: "Rare #/1100",
        img: "https://i.ibb.co/hDQ5hzR/casablanca-1-1.png",
   
        Price: "$400",
        purchasedDate: "05/12/2020",
       
    },
    {
        idx: "2",
        Title: "Mountain",
        Description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: "Rare #/1106",
        img: "https://i.picsum.photos/id/1000/5626/3635.jpg?hmac=qWh065Fr_M8Oa3sNsdDL8ngWXv2Jb-EE49ZIn6c0P-g",
       
        Price: "$800",
        purchasedDate: "05/05/2020",
    },
    {
        idx: "5",
        Title: "Planet",
        Description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: "Rare #/1151",
        img: "https://i.picsum.photos/id/1002/4312/2868.jpg?hmac=5LlLE-NY9oMnmIQp7ms6IfdvSUQOzP_O3DPMWmyNxwo",
       
        Price: "$1400",
        purchasedDate: "03/12/2018",
    },
    {
        idx: "3",
        Title: "Tree",
        Description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
        serialNo: "Rare #/1101",
        img: "https://i.picsum.photos/id/1022/6000/3376.jpg?hmac=FBA9Qbec8NfDlxj8xLhV9k3DQEKEc-3zxkQM-hmfcy0",
       
        Price: "$4900",
        purchasedDate: "03/12/2010",
    },
];
